import { DEFAULT_VISUAL_DENSITY, StatusHistoryPanelSpec, statusHistoryPanelSpecSchema } from '@/core';
import { createVisualization, mapPropsToSpec, mapSpecToProps } from '@/plugin-system';
import { StatusHistoryIcon } from './StatusHistoryIcon';
import { StatusHistoryOptionsEditor } from './StatusHistoryOptionsEditor';
import { StatusHistoryPanel } from './StatusHistoryPanel';
import { STATUS_HISTORY_PROP_TO_SPEC_MAPPING, StatusHistoryProps } from './status-history-models';

export const StatusHistory = createVisualization<StatusHistoryProps, StatusHistoryPanelSpec, object>(
  StatusHistoryPanel,
  {
    dashboardConfig: {
      kind: 'StatusHistory',
      mapSpecToProps: (spec) => mapSpecToProps(spec, STATUS_HISTORY_PROP_TO_SPEC_MAPPING),
      mapPropsToSpec: (props) => mapPropsToSpec(props, STATUS_HISTORY_PROP_TO_SPEC_MAPPING),
      panelOptionsEditorComponents: [
        {
          label: 'Settings',
          content: StatusHistoryOptionsEditor,
        },
      ],
      createInitialOptions: (): StatusHistoryPanelSpec => ({
        unit: { kind: 'Decimal' },
        thresholds: {},
        visual: { density: DEFAULT_VISUAL_DENSITY },
      }),
      contextLinkConfig: {
        scopeName: 'Cell',
        scopeVariables: ['name', 'labels.<label_name>', 'timestamp', 'value'],
      },
      schema: statusHistoryPanelSpecSchema,
      supportedDataType: 'TimeSeries',
      queryEditorCapabilities: {
        disablePerQueryThreshold: true,
      },
      icon: StatusHistoryIcon,
    },
  }
);

export type StatusHistoryVizProps = React.ComponentProps<typeof StatusHistory.Viz>;
export type StatusHistoryVizBaseProps = React.ComponentProps<typeof StatusHistory.VizBase>;
